import { Endpoints } from '@/constants';
import { store } from '@/store/store';

import { ymsAdminClient } from './taskService';

import type {
  UpdateUserLogRequestDTO,
  UpdateUserLogResponseDTO,
  GetLastTwoUserLogEventsResponseDTO,
  UpdateUserLogsConnectivityRequestDTO,
  UpdateUserLogsConnectivityResponseDTO,
} from './types/userLogTypes';

export async function updateUserLogAsync(
  request: UpdateUserLogRequestDTO
): Promise<UpdateUserLogResponseDTO> {
  const functionCode = store.getState().global.functionCodes?.user_logs ?? '';
  const { data } = await ymsAdminClient.post<UpdateUserLogResponseDTO>(
    `${Endpoints.UserLogs}${functionCode}`,
    request
  );
  return data;
}

export async function getLastTwoUserLogEvents(
  orgId: string,
  userId: string
): Promise<GetLastTwoUserLogEventsResponseDTO> {
  const functionCode = store.getState().global.functionCodes?.user_logs ?? '';
  const { data } = await ymsAdminClient.get<GetLastTwoUserLogEventsResponseDTO>(
    `${Endpoints.UserLogs}${functionCode}&org_id=${orgId}&user_id=${userId}&limit=2`
  );
  return data;
}

export async function updateUserLogsWhenInternetConnectivityChanged(
  request: UpdateUserLogsConnectivityRequestDTO
): Promise<UpdateUserLogsConnectivityResponseDTO> {
  const functionCode = store.getState().global.functionCodes?.user_logs ?? '';
  const { data } = await ymsAdminClient.post<UpdateUserLogsConnectivityResponseDTO>(
    `${Endpoints.UserLogsConnectivity}${functionCode}`,
    request
  );
  return data;
}

export const userLogApi = {
  updateUserLog: updateUserLogAsync,
  getLastTwoEvents: getLastTwoUserLogEvents,
  updateLogsOnConnectivityChange: updateUserLogsWhenInternetConnectivityChanged,
};
